export default [
    "24 24",
    '<path d="M18 12V17C18 18.6569 15.3137 20 12 20C8.68629 20 6 18.6569 6 17V12M18 12V7M18 12C18 13.6569 15.3137 15 12 15C8.68629 15 6 13.6569 6 12M18 7C18 5.34315 15.3137 4 12 4C8.68629 4 6 5.34315 6 7M18 7C18 8.65685 15.3137 10 12 10C8.68629 10 6 8.65685 6 7M6 12V7" fill="none" class="stroke-over" stroke="var(--ci-primary-color, currentColor)"  stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>'
   ]

